/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IHeiKlaviyoSignupFormViewProps } from './hei-klaviyo-signup-form';
import { subscribeToList } from './subscribeToList';

const validateEmail = (email: string) => {
    return email.toLowerCase().match(
        // eslint-disable-next-line security/detect-unsafe-regex
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export default (props: IHeiKlaviyoSignupFormViewProps) => {
    const context = props.context;
    const { listName, className, creatorTypeOptions } = props.config;
    const [email, setEmail] = React.useState('');
    const [creatorType, setCreatorType] = React.useState('');
    const [isSubmited, setIsSubmited] = React.useState(false);
    const [emailError, setEmailError] = React.useState(false);
    const [creatorTypeError, setCreatorTypeError] = React.useState(false);

    const options = React.useMemo(() => {
        const optionText = creatorTypeOptions;

        if (!optionText) {
            return [];
        }

        return optionText
            .split(';')
            .filter(s => !!s)
            .map(s => {
                const opt = s.split(':');
                return {
                    val: opt[0],
                    label: opt[1]
                };
            });
    }, [creatorTypeOptions]);

    const showCreatorType = options.length > 0;
    let wrapperCls = 'hei-klaviyo-signup-form';
    if (className) {
        wrapperCls += ` ${className}`;
    }

    if (showCreatorType) {
        wrapperCls += ` hei-klaviyo-vertical`;
    }

    return (
        <div className={`row ${wrapperCls}`}>
            {isSubmited ? (
                <div className='hei-klaviyo-signup-form-message'>{props.resources.postNewsletterSubscribeMsg}</div>
            ) : (
                <>
                    <div className='hei-klaviyo-signup-form-email form-group'>
                        {emailError && <div className='invalid-feedback'>{props.resources.emailErrorMessage}</div>}
                        <input
                            className='form-control'
                            type='email'
                            placeholder={props.resources.emailInputPlaceholder}
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                        />
                    </div>
                    {showCreatorType && (
                        <div className='hei-sailthru-signup-form-creator-type form-group'>
                            {creatorTypeError && <div className='invalid-feedback'>{props.resources.creatorTypeErrorMessage}</div>}
                            <select onChange={e => setCreatorType(e.target.value)} className='form-control'>
                                <option value=''>{props.resources.creatorTypeInputPlaceholder}</option>
                                {options.map(o => (
                                    <option key={o.val} selected={creatorType === o.val} value={o.val}>
                                        {o.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}
                    <div className='hei-klaviyo-signup-form-btn'>
                        <button
                            className='btn msc-btn'
                            type='button'
                            onClick={() => {
                                setEmailError(false);

                                var hasError = false;
                                if (!email || !validateEmail(email)) {
                                    setEmailError(true);
                                    hasError = true;
                                }

                                var props: Record<string, any> = {};
                                if (showCreatorType && !creatorType) {
                                    setCreatorTypeError(true);
                                    hasError = true;
                                } else {
                                    props['creatorType'] = creatorType;
                                }

                                if (hasError) {
                                    return;
                                }

                                void subscribeToList(context.request, { email, properties: props }, listName)
                                    .then(() => {
                                        setIsSubmited(true);
                                    })
                                    .catch(err => {
                                        console.warn('Sailthru subscription failed.');
                                    });
                            }}
                        >
                            {props.resources.submitBtnLabel}
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};
